import React from 'react';
import Header from './Header';
import { useLanguage } from '../../contexts/LanguageContext';

const Layout = ({ children, title, showLanguageToggle = true }) => {
  const { isRTL } = useLanguage();

  return (
    <div className={`min-h-screen bg-gray-50 ${isRTL ? 'font-arabic' : ''}`}>
      <Header title={title} showLanguageToggle={showLanguageToggle} />
      <main className="container mx-auto px-4 py-8">
        {children}
      </main>
    </div>
  );
};

export default Layout;